const ANDRIOD_URL = 'http://static-pro.yiguowl.top/gy_v1.0.0_03052328_dev_release.apk'
const IOS_URL = ''
const YYB_URL = ''
const JUMANG2 = ''
const ANDRIOD_URL_DEV = 'http://static-pro.yiguowl.top/gy_v1.0.0_03052328_dev_release.apk'

// 静态图片地址
const APP_FILE_URL = 'http://static-pro.yiguowl.top/'

// 红娘等级
const LEVEL_BROKER =
  [
    { 'level': 1000, 'level_des': '认证红娘一星', 'targetMoney': '300', 'targetLvl1': '0', 'targetLvl': '0', 'target': '当月收益大于300元', 'quota': '无限制' },
    { 'level': 1001, 'level_des': '认证红娘二星', 'targetMoney': '1000', 'targetLvl1': '0', 'targetLvl': '0', 'target': '当月收益大于1000元', 'quota': '无限制' },
    { 'level': 1002, 'level_des': '认证红娘三星', 'targetMoney': '2000', 'targetLvl1': '1', 'targetLvl': '1', 'target': '当月收益大于2000元，并且手下1个徒弟（不包括徒孙）', 'quota': '无限制' },
    { 'level': 1010, 'level_des': '高级红娘一星', 'targetMoney': '3000', 'targetLvl1': '2', 'targetLvl': '2', 'target': '当月收益大于3000元，并且手下2个徒弟（不包括徒孙）', 'quota': '无限制' },
    { 'level': 1011, 'level_des': '高级红娘二星', 'targetMoney': '5000', 'targetLvl1': '4', 'targetLvl': '3', 'target': '当月收益大于5000元，并且手下4个徒弟（不包括徒孙）', 'quota': '无限制' },
    { 'level': 1012, 'level_des': '高级红娘三星', 'targetMoney': '8000', 'targetLvl1': '6', 'targetLvl': '6', 'target': '当月收益大于8000元，并且手下6个徒弟（不包括徒孙）', 'quota': '无限制' },
    { 'level': 1020, 'level_des': '王牌红娘', 'targetMoney': '10000', 'targetLvl1': '10', 'targetLvl': '20', 'target': '当月收益大于10000元，并且手下10个徒弟（不包括徒孙）20个（徒弟+徒孙）', 'quota': '无限制' }
  ]

function formateLevel(level) {
  if (!level) {
    return false
  }
  let info = null
  LEVEL_BROKER.map(function(item) {
    if (item.level === level) {
      info = item
      return false
    }
  })
  return info
}

export default {
  LEVEL: LEVEL_BROKER,
  APP_FILE_URL,
  formateLevel,
  ANDRIOD_URL, // 安卓下载地址
  IOS_URL, // ios下载地址
  YYB_URL, // 应用宝下载地址
  JUMANG2,
  ANDRIOD_URL_DEV
}



// WEBPACK FOOTER //
// ./src/utils/global.js